import Toaster from "tds/toaster";
import { showToast, reset } from "tds/toaster";

export { Toaster, showToast, reset };

if (!customElements.get("tds-toaster")) {
  customElements.define("tds-toaster", Toaster.CustomElementConstructor);
}
